export const WIDE_PHONE = 480;
export const TABLET = 768;
export const DESKTOP = 1024;
export const MEDIUM = 940;
